import React, {useEffect} from "react";
import {useImmer} from 'use-immer';
import {TileListComponent} from "@/components";
import ApplyByHand from '@/Icons/applications/by-hand.svg';
import ApplyByMachine from '@/Icons/applications/by-machine.svg';

const RollLabelOptions = ({isFetching, selectDefaultSelection, loadingIndex, applicationPreSelection, children}) => {
  const [componentState, updateComponentState] = useImmer({
    application: applicationPreSelection === 0 ? 'hand_applied' : 'machine_applied',
  });

  useEffect(() => {
    updateComponentState((draft) => {
      draft.application = applicationPreSelection === 0 ? 'hand_applied' : 'machine_applied';
    });
  }, [applicationPreSelection]);

  return (
    <>
      <TileListComponent
        id='application'
        tileClassName="w-full h-6xl laptop:w-1/2 laptop:h-[70px]"
        isDisabled={isFetching}
        showIcon
        showLabel
        loadingIndex={loadingIndex}
        parentId='roll_label_options'
        LoadingIcon={() => (
          <ft-spinner size="small"></ft-spinner>
        )}
        getItemDataAttributes={(item) => ({'data-application': item.id})}
        Icon={({id, label = '', showLabel}) => {
          const attributes = {
            role: 'img',
            'aria-labelledby': 'title',
            title: label,
            className: 'w-12 h-2xl mr-2xs fill-current stroke-current',
          };

          const mapping = {
            hand_applied: <ApplyByHand {...attributes} />,
            machine_applied: <ApplyByMachine {...attributes} />,
          };

          if (id in mapping) {
            return (
              <span className="absolute inset-y-0 flex items-center">
              {mapping[id]}
                <If condition={showLabel}>
                  {label}
                </If>
              </span>
            );
          }
          return null;
        }}
        headline={
          Drupal.t('Application:')
        }
        items={
          [
            {
              label: Drupal.t("Hand Applied"),
              is_selected: componentState.application === 'hand_applied',
              id: 'hand_applied',
            },
            {
              label: Drupal.t("Machine Applied"),
              is_selected: componentState.application === 'machine_applied',
              id: 'machine_applied',
            }
          ]
        }
        onItemClick={({id}) => {
          if (id === 'hand_applied') {
            selectDefaultSelection(['model', 'refinement'], 'roll_label_options_' + id);
          }

          updateComponentState((draft) => {
            draft.application = id;
          });
        }}
      />
      <If condition={componentState.application === 'machine_applied'}>
        {children}
      </If>
    </>
  );
};

export default RollLabelOptions;
